import { render } from "./PharmacyPaymentMethod.vue?vue&type=template&id=6c49ff97&scoped=true"
import script from "./PharmacyPaymentMethod.vue?vue&type=script&lang=js"
export * from "./PharmacyPaymentMethod.vue?vue&type=script&lang=js"

import "./PharmacyPaymentMethod.vue?vue&type=style&index=0&id=6c49ff97&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c49ff97"]])

export default __exports__